import { Map } from 'immutable';
import { ReduxAction } from 'types/redux.types';
import actions from './actions';

// @ts-expect-error
const initState = new Map({
  packages: [],
  loading: false,
  denied: false,
  socialPostingPackages: [],
  loadingSocialPostingPackages: false,
  deniedSocialPostingPackages: false,
  highlightedPackages: [],
  loadingHighlightedPackages: false,
  deniedHighlightedPackages: false,
  topResultPackages: [],
  loadingTopResultPackages: false,
  deniedTopResultPackages: false,
});

export default function packagesReducer(state = initState, action: ReduxAction) {
  switch (action.type) {
    case actions.FETCH_PACKAGES_START:
      return state.set('loading', true).set('denied', false);

    case actions.FETCH_PACKAGES_DONE:
      return state.set('packages', action.payload).set('loading', false);

    case actions.FETCH_PACKAGES_DENIED:
      return state.set('denied', true);

    case actions.FETCH_PACKAGES_CANCELLED:
    case actions.FETCH_PACKAGES_ERROR:
      return state.set('loading', false);

    case actions.FETCH_SOCIAL_POSTING_PACKAGES_START:
      return state
        .set('loadingSocialPostingPackages', true)
        .set('deniedSocialPostingPackages', false);

    case actions.FETCH_SOCIAL_POSTING_PACKAGES_DONE:
      return state
        .set('socialPostingPackages', action.payload)
        .set('loadingSocialPostingPackages', false);

    case actions.FETCH_SOCIAL_POSTING_PACKAGES_DENIED:
      return state.set('deniedSocialPostingPackages', true);

    case actions.FETCH_SOCIAL_POSTING_PACKAGES_CANCELLED:
    case actions.FETCH_SOCIAL_POSTING_PACKAGES_ERROR:
      return state.set('loadingSocialPostingPackages', false);

    case actions.FETCH_HIGHLIGHTED_PACKAGES_START:
      return state.set('loadingHighlightedPackages', true).set('deniedHighlightedPackages', false);

    case actions.FETCH_HIGHLIGHTED_PACKAGES_DONE:
      return state
        .set('highlightedPackages', action.payload)
        .set('loadingHighlightedPackages', false);

    case actions.FETCH_HIGHLIGHTED_PACKAGES_DENIED:
      return state.set('deniedHighlightedPackages', true);

    case actions.FETCH_HIGHLIGHTED_PACKAGES_CANCELLED:
    case actions.FETCH_HIGHLIGHTED_PACKAGES_ERROR:
      return state.set('loadingHighlightedPackages', false);

    case actions.FETCH_TOP_RESULT_PACKAGES_START:
      return state.set('loadingTopResultPackages', true).set('deniedTopResultPackages', false);

    case actions.FETCH_TOP_RESULT_PACKAGES_DONE:
      return state.set('topResultPackages', action.payload).set('loadingTopResultPackages', false);

    case actions.FETCH_TOP_RESULT_PACKAGES_DENIED:
      return state.set('deniedTopResultPackages', true);

    case actions.FETCH_TOP_RESULT_PACKAGES_CANCELLED:
    case actions.FETCH_TOP_RESULT_PACKAGES_ERROR:
      return state.set('loadingTopResultPackages', false);

    /* default logout handler */
    case 'LOGOUT':
      return initState;
    default:
      return state;
  }
}
